module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-L-21.bf3486d2.png";